import ThirdPartyLinkNewTab from "./thirdPartyLinkNewTab";

export const thirdPartyLinkNewTab = {
  init: () => {
    const contentElements = document.querySelectorAll(".is-external-links");
    if (contentElements.length !== 0) {
      new ThirdPartyLinkNewTab(contentElements);
    }
  }
}

export default thirdPartyLinkNewTab;